export const actionResults = {
  SUCCESS: 'הצלחה',
  FAIL: 'כשלון'
}